import React from 'react';
import { useTranslation } from 'react-i18next';

import questionImage from 'assets/images/question.svg';

import { Button } from 'components/buttons';
import { Panel } from 'components/containers';
import IconCross from 'components/icons/cross';
import Modal from 'components/modal/modal';

import { LABELS } from '../apiKeys.keys';
import { ApiKeyTableRow } from '../types';
import {
  Buttons,
  Caption,
  ContentContainer,
  Delimeter,
  Image,
  ModalControls,
  ModalRoot,
  PanelContent,
  Question,
} from './deleteApiKeyModal.styles';

interface DeleteApiKeyModalProps {
  open: boolean;
  onClose: () => void;
  apiKey: ApiKeyTableRow | null;
  onDelete: (apiKeyUuid: string) => Promise<boolean>;
  isSubmitting: boolean;
}

export const DeleteApiKeyModal = ({ open, onClose, apiKey, onDelete, isSubmitting }: DeleteApiKeyModalProps) => {
  const { t } = useTranslation();

  const closeModal = () => {
    if (isSubmitting) {
      return;
    }

    onClose();
  };

  const handleDelete = async () => {
    if (isSubmitting || !apiKey) {
      return;
    }

    const success = await onDelete(apiKey.uuid);
    if (success) {
      closeModal();
    }
  };

  if (!apiKey) {
    return null;
  }

  return (
    <Modal open={open} onClose={closeModal}>
      <ModalRoot>
        <Panel
          label={t(LABELS.DELETE_MODAL.TITLE)}
          controls={
            <ModalControls>
              <Button flat onClick={closeModal} disabled={isSubmitting}>
                <IconCross />
              </Button>
            </ModalControls>
          }
        >
          <PanelContent>
            <ContentContainer>
              <Image src={questionImage} />
              <Question>{t(LABELS.DELETE_MODAL.QUESTION)}</Question>
              <Caption>{t(LABELS.DELETE_MODAL.CAPTION, { name: apiKey.name || apiKey.secretKeyTruncated })}</Caption>
            </ContentContainer>
            <Delimeter />
            <Buttons>
              <Button secondary onClick={closeModal} disabled={isSubmitting}>
                {t(LABELS.DELETE_MODAL.BUTTONS.CANCEL)}
              </Button>
              <Button danger onClick={handleDelete} disabled={isSubmitting}>
                {t(LABELS.DELETE_MODAL.BUTTONS.CONFIRM)}
              </Button>
            </Buttons>
          </PanelContent>
        </Panel>
      </ModalRoot>
    </Modal>
  );
};
